export const normalizeUrl = (
  imagePath,
  resourceDomain = process.env.REACT_APP_STRAPI_API,
) => {
  return `${resourceDomain.replace('/api/', '')}${imagePath}`;
};
